import { css, useTheme } from '@emotion/react';
import { CaseSelector } from './CaseSelector';
import { CmsLink } from 'common-ui';
import type { LinkEntryType } from 'tsconfig/types';

export const CaseSelectors = (props: any) => {
  const {
    id,
    className,
    from,
    view,
    target,
    products,
    heroCustomCtaText,
    handleViewTabPanelClick,
    handleCaseClick,
    activeCase,
    activeBottomCase,
    upsellProduct,
    upsellSelected,
    handleUpsellClick,
    customCss,
  } = props;

  const theme = useTheme();

  const cssCaseSelectors = css`
    ${theme.widgets?.CmsMultiCaseSelector?.caseSelectors}
    ${customCss}
  `;

  const TARGET_PANEL = 'target-panel';

  const customCta = {
    fields: {
      url: target,
      title: heroCustomCtaText,
    },
  };

  const STICKY_BANNER = 'sticky-banner';

  return (
    <div id={id} className={className} css={cssCaseSelectors} data-testid={id}>
      {from !== STICKY_BANNER && from !== 'landing-target-panel' && (
        <div className="mcs-selector__header">
          {from === TARGET_PANEL ? (
            <div className="h1">What's in the case?</div>
          ) : (
            <>
              <span>Choose your case</span>
              <a href={target} className="eyebrow" onClick={e => handleViewTabPanelClick(e)}>
                What's in the Case?
              </a>
            </>
          )}
        </div>
      )}
      <div className={`mcs-selector__list ${view}`} role="tablist" aria-orientation="horizontal">
        {products.map((item: any, index: number) => (
          <CaseSelector
            key={`case-selector-${item?.name}`}
            item={item}
            index={index}
            from={from}
            view={view}
            activeCase={activeCase}
            activeBottomCase={activeBottomCase}
            handleClick={handleCaseClick}
          />
        ))}

        {upsellProduct && (
          <CaseSelector
            item={upsellProduct}
            index={from === TARGET_PANEL || from === STICKY_BANNER ? products.length : null}
            from={from}
            view={'simple'}
            type={'upsell'}
            activeCase={activeCase}
            activeBottomCase={activeBottomCase}
            upsellSelected={upsellSelected}
            handleClick={handleUpsellClick}
          />
        )}

        {from === STICKY_BANNER && heroCustomCtaText && (
          <CmsLink contentItem={customCta as LinkEntryType} className="view-product-button" />
        )}
      </div>
    </div>
  );
};
